// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { SummarySourceType } from "../schema";

export function serialize_SummarySourceType_internal(value: SummarySourceType): unknown {
  return ((value: "BOOK" | "VIDEO" | "ARTICLE" | "CHAPTER" | "REPORT" | "PODCAST"): unknown => {
    return value;
  })(value);
}
export function serialize_SummarySourceType(obj: SummarySourceType): string {
  return renderJsonWithNumbersAsBigint(serialize_SummarySourceType_internal(obj));
}
export function deserialize_SummarySourceType_internal(value: unknown): ParserResult<SummarySourceType> {
  return ((value: unknown): ParserResult<"BOOK" | "VIDEO" | "ARTICLE" | "CHAPTER" | "REPORT" | "PODCAST"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/SummarySourceType]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "BOOK":
        return { success: true, value: "BOOK" };
      case "VIDEO":
        return { success: true, value: "VIDEO" };
      case "ARTICLE":
        return { success: true, value: "ARTICLE" };
      case "CHAPTER":
        return { success: true, value: "CHAPTER" };
      case "REPORT":
        return { success: true, value: "REPORT" };
      case "PODCAST":
        return { success: true, value: "PODCAST" };
      default:
        return { success: false, reason: `[#/components/schemas/SummarySourceType]: '${value}' expected to be enum, one of 'BOOK, VIDEO, ARTICLE, CHAPTER, REPORT, PODCAST'.` };
    }
  })(value);
}
export function deserialize_SummarySourceType(str: string): ParserResult<SummarySourceType> {
  return deserialize_SummarySourceType_internal(parseJsonWithNumbersAsBigint(str));
}
